<template>
    <default-item class="menu--item-wv_steak_house_food" :item="item"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for WV Steak House food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - <biminiFoodItem> copied to <WVSteakHouseFoodItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <WVSteakHouseFoodItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'WVSteakHouseFoodItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
})
</script>

<style scoped>

</style>